import { gtmEvent } from '../../utils/gtmEvents';
import { store } from '../store';
const gtmBapDispatch = ({ calculatorId, event, termWithRateData, additionalSavingsOffers }) => {
    var _a, _b, _c, _d;
    const state = store.getState();
    const currentCalculator = state.financialCalculators[calculatorId];
    if (currentCalculator === undefined) {
        return;
    }
    const { paymentMethod, paymentFrequency, termAndRate: term, incentiveOfferIds } = currentCalculator;
    const termAndRates = termWithRateData === null || termWithRateData === void 0 ? void 0 : termWithRateData.terms;
    const rate = (_a = termAndRates === null || termAndRates === void 0 ? void 0 : termAndRates.find(termAndRate => termAndRate.term === term)) === null || _a === void 0 ? void 0 : _a.apr;
    const gtmData = {};
    gtmData.event = event;
    if (paymentMethod) {
        gtmData.payment_option = paymentMethod;
    }
    if (term) {
        gtmData.payment_term = term;
    }
    if (paymentFrequency) {
        gtmData.payment_frequency = paymentFrequency;
    }
    if (rate) {
        gtmData.payment_term_rate = rate;
    }
    if (incentiveOfferIds) {
        const offers = additionalSavingsOffers.filter(offer => incentiveOfferIds.some(incentive => incentive === offer.id));
        const savingsMilitaryDiscount = (_b = offers.find(offer => (offer === null || offer === void 0 ? void 0 : offer.name.toLowerCase()) === 'military discount')) === null || _b === void 0 ? void 0 : _b.value;
        if (savingsMilitaryDiscount) {
            gtmData.savings_military_discount = savingsMilitaryDiscount;
        }
        const savingsStudentDiscount = (_c = offers.find(offer => (offer === null || offer === void 0 ? void 0 : offer.name.toLowerCase()) === 'student discount')) === null || _c === void 0 ? void 0 : _c.value;
        if (savingsStudentDiscount) {
            gtmData.savings_student_discount = savingsStudentDiscount;
        }
        const savingsNewcomer = (_d = offers.find(offer => (offer === null || offer === void 0 ? void 0 : offer.name.toLowerCase()) === 'newcomer to canada')) === null || _d === void 0 ? void 0 : _d.value;
        if (savingsNewcomer) {
            gtmData.savings_newcomer = savingsNewcomer;
        }
    }
    gtmEvent(gtmData);
};
export default gtmBapDispatch;
